import { render, staticRenderFns } from "./NewConversationButtonWithModal.vue?vue&type=template&id=3813f5ea"
import script from "./NewConversationButtonWithModal.vue?vue&type=script&lang=ts"
export * from "./NewConversationButtonWithModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3813f5ea')) {
      api.createRecord('3813f5ea', component.options)
    } else {
      api.reload('3813f5ea', component.options)
    }
    module.hot.accept("./NewConversationButtonWithModal.vue?vue&type=template&id=3813f5ea", function () {
      api.rerender('3813f5ea', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/inbox/NewConversationButtonWithModal.vue"
export default component.exports